import { useEffect } from 'react'

const cioScript = (writeKey: string, siteId: string) => `
 !function(){var i="cioanalytics", analytics=(window[i]=window[i]||[]);if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.setAttribute('data-global-customerio-analytics-key', i);t.src="https://cdp.customer.io/v1/analytics-js/snippet/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._writeKey=key;analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.15.3";
 analytics.load(
     "${writeKey}",
     {
         "integrations": {
             "Customer.io In-App Plugin": {
                 siteId: "${siteId}",
                 events: function(event) {
                    // Create and dispatch a custom event with the full event data
                    const customEvent = new CustomEvent('customerio-event', {
                        detail: event
                    });
                    window.dispatchEvent(customEvent);
                }
             }
         }
     }
 );
 }}();
`

const ExternalScripts = () => {
  function addScript(src: string) {
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.async = true
    s.innerHTML = src
    document.head.appendChild(s)
  }

  useEffect(() => {
    const cioWriteKey = import.meta.env.VITE_CIO_WRITE_KEY
    const cioSiteId = import.meta.env.VITE_CIO_SITE_ID

    if (cioWriteKey && cioSiteId) {
      addScript(cioScript(cioWriteKey, cioSiteId))
    }
  }, [])

  return null
}

export default ExternalScripts